import type { SxProps, Theme } from '@/ui/primitives';

export const tableV2HeaderLabelSx = {
  display: 'block',
  lineHeight: 1.3,
  maxWidth: '100%',
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
} satisfies SxProps<Theme>;
